
import Utils from 'assets/utils.js'

export default {
  props: {
    prev: {
      type: Object,
      default: () => null
    },
    next: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      links: [
        {
          position: 'prev',
          link: this.prev
        },
        {
          position: 'next',
          link: this.next
        }
      ]
    }
  },
  methods: {
    prettifyDate (date) {
      return Utils.prettifyDate2(date)
    }
  }
}
